/**
 * @generated SignedSource<<310d9d15a8f9ff9c741299d65651453d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NovaAgentShape = "SINGLE_OUTPUT" | "CONVERSATIONAL" | "%future added value";
export type UpdateNovaAgentInput = {
  id: string;
  name: string;
  categoryId: string;
  title: string;
  description: string;
  shape: NovaAgentShape;
  systemPrompt?: string | null;
  userPromptTemplate?: string | null;
  agentMd?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateNovaAgentMutation$variables = {
  input: UpdateNovaAgentInput;
};
export type UpdateNovaAgentMutation$data = {
  readonly updateNovaAgent: {
    readonly agent: {
      readonly id: string;
      readonly name: string | null;
      readonly title: string | null;
      readonly description: string | null;
      readonly shape: NovaAgentShape | null;
      readonly categoryId: string | null;
    } | null;
  } | null;
};
export type UpdateNovaAgentMutation = {
  variables: UpdateNovaAgentMutation$variables;
  response: UpdateNovaAgentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateNovaAgentPayload",
    "kind": "LinkedField",
    "name": "updateNovaAgent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shape",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateNovaAgentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateNovaAgentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8d12599bffe50dd4095e4e69528da986",
    "id": null,
    "metadata": {},
    "name": "UpdateNovaAgentMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateNovaAgentMutation(\n  $input: UpdateNovaAgentInput!\n) {\n  updateNovaAgent(input: $input) {\n    agent {\n      id\n      name\n      title\n      description\n      shape\n      categoryId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c3f82c793c5991473fa0ca1a9db87fa";

export default node;
